import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { fetchBlogPosts } from '../services/api';
import { blogPosts as mockBlogPosts } from '../mockData';

const BlogSection = () => {
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    const loadBlogPosts = async () => {
      try {
        const data = await fetchBlogPosts(3);
        setBlogPosts(data);
      } catch (error) {
        console.error('Failed to fetch blog posts, using mock data:', error);
        setBlogPosts(mockBlogPosts);
      }
    };

    loadBlogPosts();
  }, []);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-light text-center mb-12 text-gray-800">
          Diamond Q Jewelers Blog
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article key={post.id} className="group">
              <div className="bg-gray-100 aspect-video mb-4 rounded-sm overflow-hidden">
                <img
                  src={`https://images.unsplash.com/photo-${index === 0 ? '1605100804763-247f67b3557e' : index === 1 ? '1515562141207-7a88fb7ce338' : '1603561596112-0a132b757442'}?w=600&q=80`}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <h3 className="text-xl font-normal mb-3 text-gray-800 group-hover:text-gray-600 transition-colors">
                {post.title}
              </h3>
              <p className="text-gray-600 mb-4 leading-relaxed text-sm">
                {post.excerpt}
              </p>
              <Button
                variant="link"
                className="text-gray-800 hover:text-gray-600 p-0 h-auto font-normal"
              >
                Read More
                <ArrowRight size={16} className="ml-2" />
              </Button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;